var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _ = require("underscore");
var GraphieClasses = require("./graphie-classes.jsx");
var Interactive2 = require("../interactive2.js");

var KhanColors = require("../util/colors.js");

var MovablePoint = GraphieClasses.createClass({
    displayName: "MovablePoint",

    movableProps: ["children"],

    _getProps: function _getProps() {
        if (this.props.isMobile) {
            var isMobile = this.props.isMobile;

            // TODO(kevinb) precompute commonStyle and commonMobileStyle
            /* eslint-disable indent */
            var commonStyle = isMobile ? {
                stroke: "#ffffff",
                "stroke-width": 3,
                fill: KhanColors.INTERACTIVE
            } : {
                stroke: KhanColors.INTERACTIVE,
                fill: KhanColors.INTERACTIVE
            };

            // TODO(kevinb) precompute normalStyle and normalMobileStyle
            var normalStyle = isMobile ? Object.assign(commonStyle, this.props.mobileStyleOverride || {}) : Object.assign(commonStyle, this.props.normalStyle);

            // TODO(kevinb) precompute highlightStyle and highlightMobileStyle
            var highlightStyle = isMobile ? _extends({}, commonStyle, {
                "stroke-width": 0,
                scale: 0.75
            }) : this.props.highlightStyle;
            /* eslint-enable indent */

            var addedProps = Object.assign({
                normalStyle: normalStyle,
                highlightStyle: highlightStyle,
                shadow: isMobile,
                tooltip: isMobile && this.props.showTooltips
            }, isMobile ? { pointSize: 7 } : {});

            return Object.assign(this.props, addedProps);
        } else {
            return this.props;
        }
    },

    add: function add(graphie) {
        this.point = Interactive2.addMovablePoint(graphie, this._getProps());
    },

    modify: function modify() {
        this.point.modify(this._getProps());
    },

    remove: function remove() {
        this.point.remove();
    },

    toFront: function toFront() {
        this.point.toFront();
    },

    grab: function grab(coord) {
        this.point.grab(coord);
    }
});

// Include helper methods, such as MovablePoint.constrain.snap()
_.extend(MovablePoint, Interactive2.MovablePoint);

var MovableLine = GraphieClasses.createClass({
    displayName: "MovableLine",

    movableProps: ["children"],

    add: function add(graphie) {
        // Add MovablePoint children
        var points = _.pluck(this.props.children, "point");
        var props = _.extend({}, this.props, {
            points: points
        });
        this.line = Interactive2.addMovableLine(graphie, props);
    },

    modify: function modify() {
        // Add MovablePoint children
        var points = _.pluck(this.props.children, "point");
        var props = _.extend({}, this.props, {
            points: points
        });
        this.line.modify(props);
    },

    remove: function remove() {
        this.line.remove();
    },

    toFront: function toFront() {
        this.line.toFront();
    }
});

// Include helper methods, such as MovableLine.constrain.snap()
_.extend(MovableLine, Interactive2.MovableLine);

var Label = GraphieClasses.createSimpleClass(function (graphie, props) {
    var coord = props.coord;
    if (props.unscaled) {
        coord = graphie.unscalePoint(coord);
    }

    return graphie.label(coord, props.text, props.direction, props.tex, props.style);
});

var Line = GraphieClasses.createClass({
    displayName: "Line",

    movableProps: ["children"],

    add: function add(graphie) {
        var props = this.props;
        this.graphie = graphie;
        this.line = this.graphie.line(props.start, props.end, props.style);
    },

    modify: function modify() {
        var props = this.props;
        var path = this.graphie.svgPath([props.start, props.end]);
        this.line.attr(_.extend({}, props.style, { path: path }));
    },

    remove: function remove() {
        this.line.remove();
    },

    toFront: function toFront() {
        this.line.toFront();
    }
});

var Parabola = GraphieClasses.createClass({
    displayName: "Parabola",

    movableProps: ["children"],

    add: function add(graphie) {
        var props = this.props;
        this.graphie = graphie;
        this.parabola = this.graphie.parabola(props.a, props.b, props.c, props.style);
    },

    modify: function modify() {
        var props = this.props;
        var path = this.graphie.svgParabolaPath(props.a, props.b, props.c);
        this.parabola.attr(_.extend({}, props.style, { path: path }));
    },

    remove: function remove() {
        this.parabola.remove();
    },

    toFront: function toFront() {
        this.parabola.toFront();
    }
});

var Sinusoid = GraphieClasses.createClass({
    displayName: "Sinusoid",

    movableProps: ["children"],

    add: function add(graphie) {
        var props = this.props;
        this.graphie = graphie;
        this.sinusoid = this.graphie.sinusoid(props.a, props.b, props.c, props.d, props.style);
    },

    modify: function modify() {
        var props = this.props;
        var path = this.graphie.svgSinusoidPath(props.a, props.b, props.c, props.d);
        this.sinusoid.attr(_.extend({}, props.style, { path: path }));
    },

    remove: function remove() {
        this.sinusoid.remove();
    },

    toFront: function toFront() {
        this.sinusoid.toFront();
    }
});

var Plot = GraphieClasses.createSimpleClass(function (graphie, props) {
    return graphie.plot(props.fn, props.range, props.style);
});

var PlotParametric = GraphieClasses.createSimpleClass(function (graphie, props) {
    return graphie.plotParametric(props.fn, props.range, props.style);
});

var Point = GraphieClasses.createSimpleClass(function (graphie, props) {
    return graphie.ellipse(props.coord, graphie.unscaleVector([4, 4]), {
        fill: props.color || KhanColors.BLACK,
        stroke: props.color || KhanColors.BLACK
    });
});

var Path = GraphieClasses.createClass({
    displayName: "Path",

    movableProps: ["children"],

    add: function add(graphie) {
        var props = this.props;
        this.graphie = graphie;
        this.path = this.graphie.path(props.coords, props.style);
    },

    modify: function modify() {
        var props = this.props;
        var path = this.graphie.svgPath(props.coords);
        this.path.attr({ path: path });
    },

    remove: function remove() {
        this.path.remove();
    },

    toFront: function toFront() {
        this.path.toFront();
    }
});

var Arc = GraphieClasses.createSimpleClass(function (graphie, props) {
    var center = props.center;
    var radius = props.radius;
    if (props.unscaled) {
        center = graphie.unscalePoint(center);
        radius = graphie.unscaleVector(radius);
    }

    return graphie.arc(center, radius, props.startAngle, props.endAngle, props.sector, props.style);
});

var Circle = GraphieClasses.createSimpleClass(function (graphie, props) {
    return graphie.circle(props.center, props.radius, props.style);
});

var Rect = GraphieClasses.createSimpleClass(function (graphie, props) {
    return graphie.rect(props.x, props.y, props.width, props.height, props.style);
});

module.exports = {
    Arc: Arc,
    Circle: Circle,
    Label: Label,
    Line: Line,
    MovableLine: MovableLine,
    MovablePoint: MovablePoint,
    Parabola: Parabola,
    Path: Path,
    Plot: Plot,
    PlotParametric: PlotParametric,
    Point: Point,
    Sinusoid: Sinusoid,
    Rect: Rect
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/graphie-movables.jsx
 ** module id = 277
 ** module chunks = 0 2
 **/